import * as React from "react";

export const EditButtons: React.FC<{
  onClickEdit: () => any;
  onClickDelete: () => any;
}> = ({ onClickEdit, onClickDelete }) => {
  const style = { marginRight: "10px", cursor: "pointer" };
  return (
    <>
      <i className="fa fa-edit" style={style} onClick={onClickEdit} />
      <i className="fa fa-trash" style={style} onClick={onClickDelete} />
    </>
  );
};
